import React from 'react';
import ServiceDetailsIntro from '../components/service-details/ServiceDetailsIntro';
import ServiceDetails from '../components/service-details/ServiceDetails';
import ServiceOffer from '../components/service-details/ServiceOffer';

const ServiceDetailsPage = () => {
    return (
        <main id="infocolors-main">
            <div className="stg-container">
                <ServiceDetailsIntro />
                <ServiceDetails />
                <ServiceOffer />
            </div>
        </main>
    );
};

export default ServiceDetailsPage;
